import {
  createMultiStyleConfigHelpers,
  MultiStyleType,
  StyleThemingProps,
} from '~/utils/chakraUtils'
import { mergeMultiStyleConfig } from '~/utils/styleHelpers'

export const enum ToggleListButtonVariants {
  Default = 'default',
  Disabled = 'disabled',
}

const ToggleListButtonParts = ['container', 'iconButton', 'icon'] as const

const helpers = createMultiStyleConfigHelpers(ToggleListButtonParts)

export const ToggleListButtonStyle = helpers.defineMultiStyleConfig({
  baseStyle: {
    container: {
      display: 'flex',
      width: 'full',
      alignItems: 'center',
      justifyContent: 'center',
      borderBottom: '2px solid',
      borderColor: 'border.muted',
      paddingTop: 2,
      paddingBottom: 2,
      backgroundColor: 'brand.subtle',
    },
    iconButton: {
      display: 'flex',
      minWidth: '32px',
      width: 'auto',
      height: '32px',
      marginBottom: '8px',
      alignItems: 'center',
      justifyContent: 'center',
      backgroundColor: 'transparent',
      color: 'fg.default',
    },
    icon: {
      boxSize: '1.25rem',
    },
  },
  variants: {
    [ToggleListButtonVariants.Default]: {
      container: {
        cursor: 'pointer',
        _hover: {
          backgroundColor: 'brand.emphasized',
        },
        _active: {
          backgroundColor: 'brand.emphasized',
        },
      },
    },
    [ToggleListButtonVariants.Disabled]: {
      iconButton: {
        '& > svg': {
          color: 'brand.emphasized',
        },
      },
    },
  },
})

export const useToggleListButtonStyles = (props?: StyleThemingProps) => {
  return mergeMultiStyleConfig(ToggleListButtonStyle, props) as MultiStyleType<
    typeof ToggleListButtonParts
  >
}
